import { InputNumberProps } from 'antd/lib/input-number'
import { thosandSeprartor } from '@/utils/form'
import InputNumber from './InputNumber'

const ThousandSeprartorInput = ({ ...props }: InputNumberProps) => (
  <InputNumber {...props} {...thosandSeprartor} />
)

export default ThousandSeprartorInput
